import * as Period from '../../../../constants/Period';
var RAFBY_PERIOD_MAP = {};
RAFBY_PERIOD_MAP[900] = Period.NOT_STARTED;
RAFBY_PERIOD_MAP[901] = Period.FIRST;
RAFBY_PERIOD_MAP[902] = Period.FIRST_BREAK;
RAFBY_PERIOD_MAP[903] = Period.SECOND;
RAFBY_PERIOD_MAP[904] = Period.FINISHED;
export default RAFBY_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/Rugby/PeriodMap.js